const refinedState  = () => {
    return {
        refinedContents:null
    };
  };


  export default refinedState;